import { render, staticRenderFns } from "./allow_email_receipts.vue?vue&type=template&id=cba8f79e&"
import script from "./allow_email_receipts.vue?vue&type=script&lang=js&"
export * from "./allow_email_receipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports